module.exports = __webpack_public_path__ + "img/step4.1b2095da.png";